export const storage = {
  get: (key: string) => localStorage.getItem(key),
  set: (key: string, value: string) => localStorage.setItem(key, value),
  getNumber: (key: string) => Number(localStorage.getItem(key)),
  getJSON: (key: string) => JSON.parse(localStorage.getItem(key) ?? '""') as unknown,
  remove: (key: string) => localStorage.removeItem(key),
  clear: () => localStorage.clear()
}
